import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserActionsComponent } from './user-actions.component';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { ButtonModule } from 'primeng/button';
import { MegaMenuModule } from 'primeng/megamenu';
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { ToastModule } from 'primeng/toast';
import { PopoverModule } from 'primeng/popover';
import { DrawerModule } from 'primeng/drawer';

@NgModule({
  declarations: [UserActionsComponent],
  imports: [CommonModule, AvatarModule, AvatarGroupModule, ButtonModule, MegaMenuModule, MenuModule, MenubarModule, TieredMenuModule, ToastModule, PopoverModule, DrawerModule],
  exports: [UserActionsComponent],
})
export class UserActionsModule {}
